$(document).ready(function () {
  $('.actions button').click(function () {
    var details = $(this).closest('li').find('.details')
    details.toggleClass('hidden')
  })
})
